import { createSlice } from "@reduxjs/toolkit";

export const stockSlice = createSlice({
  name: "stock",
  initialState: {
    all: [],
    byId: [],
    isLoading: true,
    ledger: {
      all: [],
      byId: [],
      isLoading: true,
    },
    supplier: {
      all: [],
      byId: [],
      isLoading: true,
      price: {
        all: [],
        byId: [],
        isLoading: true,
      },
    },
  },
  reducers: {
    load: (state, action) => {
      state.all = action.payload.data;
      state.byId = action.payload.data.map((data) => data.id);
      state.isLoading = false;
    },

    update: (state, action) => {
      state.all = state.all.map((item) =>
        item.id === action.payload.id ? { ...item, ...action.payload } : item
      );
    },
    create: (state, action) => {
      state.all.push({ ...action.payload });
      state.byId.push(action.payload.id);
    },
    remove: (state, action) => {
      state.all = state.all.reduce(
        (agg, item) =>
          parseInt(item.id) === action.payload ? agg : [...agg, item],
        []
      );

      state.byId = [...state.byId].reduce(
        (agg, item) =>
          parseInt(item) === action.payload ? agg : [...agg, item],
        []
      );
    },

    loadLedger: (state, action) => {
      state.ledger.all = action.payload.data;
      state.ledger.byId = action.payload.data.map((data) => data.id);
      state.ledger.isLoading = false;
    },

    updateLedger: (state, action) => {
      state.ledger.all = state.ledger.all.map((item) =>
        item.id === action.payload.id ? { ...item, ...action.payload } : item
      );
    },

    createLedger: (state, action) => {
      state.ledger.all.push({ ...action.payload });
      state.ledger.byId.push(action.payload.id);
    },

    removeLedger: (state, action) => {
      state.ledger.all = state.ledger.all.reduce(
        (agg, item) =>
          parseInt(item.id) === action.payload ? agg : [...agg, item],
        []
      );

      state.ledger.byId = state.ledger.byId.reduce(
        (agg, item) =>
          parseInt(item) === action.payload ? agg : [...agg, item],
        []
      );
    },

    loadSupplier: (state, action) => {
      state.supplier.all = action.payload.data;
      state.supplier.byId = action.payload.data.map((data) => data.id);
      state.supplier.isLoading = false;
    },

    updateSupplier: (state, action) => {
      state.supplier.all = state.supplier.all.map((item) =>
        item.id === action.payload.id ? { ...item, ...action.payload } : item
      );
    },

    createSupplier: (state, action) => {
      state.supplier.all.push({ ...action.payload });
      state.supplier.byId.push(action.payload.id);
    },

    removeSupplier: (state, action) => {
      state.supplier.all = state.supplier.all.reduce(
        (agg, item) =>
          parseInt(item.id) === action.payload ? agg : [...agg, item],
        []
      );

      state.supplier.byId = state.supplier.byId.reduce(
        (agg, item) =>
          parseInt(item) === action.payload ? agg : [...agg, item],
        []
      );
    },

    loadSupplierPrice: (state, action) => {
      state.supplier.price.all = action.payload.data;
      state.supplier.price.byId = action.payload.data.map((data) => data.id);
      state.supplier.price.isLoading = false;
    },

    updateSupplierPrice: (state, action) => {
      state.supplier.price.all = state.supplier.price.all.map((item) =>
        item.id === action.payload.id ? { ...item, ...action.payload } : item
      );
    },

    createSupplierPrice: (state, action) => {
      state.supplier.price.all.push({ ...action.payload });
      state.supplier.price.byId.push(action.payload.id);
    },

    removeSupplierPrice: (state, action) => {
      state.supplier.price.all = state.supplier.price.all.reduce(
        (agg, item) =>
          parseInt(item.id) === action.payload ? agg : [...agg, item],
        []
      );

      state.supplier.price.byId = state.supplier.price.byId.reduce(
        (agg, item) =>
          parseInt(item) === action.payload ? agg : [...agg, item],
        []
      );
    },
  },
});

export const {
  load,
  create,
  update,
  remove,
  loadLedger,
  createLedger,
  updateLedger,
  removeLedger,
  loadSupplier,
  createSupplier,
  updateSupplier,
  removeSupplier,
  loadSupplierPrice,
  createSupplierPrice,
  updateSupplierPrice,
  removeSupplierPrice,
} = stockSlice.actions;

export default stockSlice.reducer;
